import React from 'react'
import LotteryResultSectionHeader from '../LotteryResultSectionHeader'

/** Static mock section: จับยี่กี (current round) */
const LotteryResultStaticYeekeeCurrent: React.FC = () => (
  <div className="col-12 col-lg-6 px-1 mb-4">
    <LotteryResultSectionHeader
      title="จับยี่กี"
      iconUrl="logo.png"
      drawLabel="รอบ 21:00 น."
    />
    <div className="wrap-box p-2 pt-0 bgg-7 bdr-5">
      <div className="row mx--1">
        <div className="col-12 px--1 mt-2 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>รอบที่ 123</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h4>เวลา :21:00 น.</h4>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 px--1 mt-1 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>3ตัวบน</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>432</h5>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 px--1 mt-1 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>2ตัวล่าง</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>20</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LotteryResultStaticYeekeeCurrent
